module.exports = __webpack_public_path__ + "img/logo-dropsmith-size.254c6e39.png";